var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.preloader),expression:"preloader"}],staticClass:"load"},[_c('div',{staticClass:"gauge-loader"},[_vm._v("Loading... ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }